import { Component, OnInit, ViewChild, AfterViewInit, Input, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { environment } from '../../../../../src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from './actiona-dialog.component';
import { Observable } from 'rxjs';
import { StudentDetailsComponent } from '../../../../../src/app/views/pages/coursera-admin/components/student-details/student-details.component';
import { HEC_CONSTANTS } from '../../../../../src/app/utilities/constants';
@Component({
  selector: 'task-table',
  templateUrl: 'task-table.component.html',
  styleUrls: ['task-table.component.scss'],
  providers: []
})
export class TaskTableComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() tablePayload: any;
  private gridUrl = environment.BASE_URL_PCD + 'coursera/applicant-details';
  private approveUrl = environment.BASE_URL_PCD + 'coursera/approve-applicants';
  private blockOrRejectUrl = environment.BASE_URL_HRD + 'courseraAdmin/updateApplicationStatus';

  displayedColumns: string[] = [
    'id',
    'cnic',
    'name',
    'email',
    'rollNum',
    'universityName',
    'province',
    'status',
    'focalPersonDecisionComments',
    'adminDecisionComments',
    'applicantType',
    'submittedDatetime'
  ];

  columnDisplayNames: { [key: string]: string } = {
    id: 'ID',
    cnic: 'CNIC',
    name: 'Name',
    email: 'Email',
    rollNum: 'Roll Number',
    universityName: 'University Name',
    province: 'Province',
    status: 'Status',
    focalPersonDecisionComments: 'Focal Comments',
    adminDecisionComments: 'Admin Comments',
    applicantType: 'Applicant Type',
    submittedDatetime: 'Submitted Date'
  };

  searchColumns = [
    'id',
    'cnic',
    'name',
    'universityName',
    'universityId',
    'province',
    'email',
    'rollNum',
    'status',
    'focalPersonDecisionComments',
    'adminDecisionComments',
    'applicantType',
    'statusId',
    'submittedDatetime',
  ];
  fullDisplayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>([]);
  selection = new SelectionModel<any>(true, []);
  totalItems = 0;
  pageNumber = 0;
  pageSize = 5;

  visibleSearch: { [key: string]: boolean } = {};
  searchColumn = ''; // Tracks which column is being searched
  showSearchRow = false; // Controls visibility of search row
  showSearchField = false;
  submittedStatus = 401402;
  payload = {
    statusId: this.submittedStatus,
    configId: 0,
    pageNumber: 0,
    pageSize: 5
  }
  loading: boolean = false;
  private viewInitialized = false;

  filters: { [key: string]: string } = {};
  activeSearchColumns: string[] = []; 
  searchValue: string = '';


  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(private http: HttpClient, private dialog: MatDialog,private cdRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.fullDisplayedColumns = ['select', ...this.displayedColumns];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.tablePayload || !this.viewInitialized) {
      return;
    }

    const previousValue = changes.tablePayload.previousValue;
    const currentValue = changes.tablePayload.currentValue;
    const previousBatch = previousValue ? previousValue.currentBatch : null;
    const currentBatch = currentValue ? currentValue.currentBatch : null;

    if (currentBatch === null || currentBatch === undefined) {
      return;
    }

    if (previousBatch !== currentBatch) {
      this.pageNumber = 0;
      this.loadData();
    }
  }

  ngAfterViewInit() {
    this.viewInitialized = true;
    this.dataSource.sort = this.sort;
    if (this.tablePayload && this.tablePayload.currentBatch !== null && this.tablePayload.currentBatch !== undefined) {
      this.loadData();
    }
    // this.dataSource.paginator = this.paginator;
  }

  customSort(column: string) {
    const isAsc = this.sort.active === column && this.sort.direction === 'asc';
    this.sort.active = column;
    this.sort.direction = isAsc ? 'desc' : 'asc';
    this.sort.sortChange.emit({ active: column, direction: this.sort.direction });
  }

  searchField(value: string, column: string): void {
    this.filters[column] = value.trim();
    this.loadData();
  }



  toggleSearchField(column: string): void {
    this.searchColumn = column;
    this.searchValue = this.filters[column] || '';
  }

  addFilter(): void {
    if (this.searchColumn && this.searchValue !== '') {
      this.filters[this.searchColumn] = this.searchValue;
      if (!this.activeSearchColumns.includes(this.searchColumn)) {
        this.activeSearchColumns.push(this.searchColumn);
      }

      // Reset input
      this.searchColumn = '';
      this.searchValue = '';

      this.loadData();
    }
  }




  clearFilter(column: string): void {
    delete this.filters[column];
    this.activeSearchColumns = this.activeSearchColumns.filter(c => c !== column);
    this.loadData();
  }


  onPaginateChange(event: PageEvent): void {      
    this.pageNumber = event.pageIndex
    this.pageSize = event.pageSize
    this.loadData();
  }


  onSearchValueChange(column: string, value: string): void {
    this.filters[column] = value.trim();
  }


  clearSearch(): void {
    this.showSearchField = false;
    this.loadData();
  }

  public compare(column: string): boolean {
    const res = this.searchColumn.toLowerCase() === column.toLowerCase();
    return res;
  }

  loadData(): void {
    if (!this.tablePayload || this.tablePayload.currentBatch === null || this.tablePayload.currentBatch === undefined) {
      this.loading = false;
      this.dataSource.data = [];
      this.totalItems = 0;
      return;
    }

    this.loading = true;
    this.getApplicantDetails().subscribe(
      response => {
        const responseData = response && response.data ? response.data : {};
        const rows = responseData && Array.isArray(responseData.data) ? responseData.data : [];

        this.dataSource.data = rows;
        this.totalItems = typeof responseData.page === 'number' ? responseData.page : rows.length;
        this.selection.clear();
        this.loading = false; 
        this.cdRef.detectChanges();
      },
      error => {
        console.error('Error loading data', error);
        this.loading = false;
      }
    );
  }


  toggleRow(row: any): void {

    this.selection.toggle(row);


  }

  toggleAllRows(event: any): void {

    if (event.checked) {
      this.selection.select(...this.dataSource.data);
    } else {
      this.selection.clear();
    }
  }

  isApproveDisabled(statusId: number): boolean {
    return statusId === 401408 || statusId === 401413;
  }

  isBlockDisabled(statusId: number): boolean {
    return statusId === 401407 || statusId === 401411;
  }

  isRejectDisabled(statusId: number): boolean {
    return [401409, 401408, 401407, 401411, 401412].includes(statusId);
  }


  isAllSelected(): boolean {
    return this.selection.selected.length === this.dataSource.data.length;
  }

  isSomeSelected(): boolean {
    return this.selection.selected.length > 0 && !this.isAllSelected();
  }


  confirmAction(action: 'approve' | 'block' | 'reject', target: any | any[]) {
    this.loading = true
    const isMultiple = Array.isArray(target);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: { action, isMultiple, role: this.tablePayload.currentRole, acronym: this.tablePayload.acronym }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;


      if (action === 'approve') {
        const ids = Array.isArray(target) ? target.map(t => t.id) : [target.id];
        this.approveApplicants(ids).subscribe(
          response => {
            this.showSearchField = false;
            this.loadData();
            return;
          },
          error => {
          }
        );

      }

      if (action === 'reject' || action === 'block') {
        const { comment, onBehalf } = result;
        this[action](target, comment, onBehalf);
        const payload = {
          id: target.id,
          status: 0,
          adminDecisionComments: '',
          focalPersonDecisionComments: ''
        };

        if (this.tablePayload.currentRole === 'ADMIN' && this.tablePayload.acronym === 'COURSERA') {
          payload.status = action === 'block' ? 401407 : 401409;
          payload.adminDecisionComments = comment

        } else if (this.tablePayload.currentRole === 'FOCAL_PERSON' && this.tablePayload.acronym === 'COURSERA') {
          payload.status = action === 'block' ? 401411 : 401413;
          payload.focalPersonDecisionComments = comment
        }



        this.blockOrReject(payload).subscribe(
          response => {
            console.log('blockReject successful:', response);
            this.loadData();
            return;
          },
          error => {
            console.error('blockReject failed:', error);
          }
        );
      }
    });
  }

  approveApplicants(ids: number[]) {
    const payload = {
      applicants: {
        ids: ids
      }
    };

    return this.http.put(this.approveUrl, payload);
  }

  blockOrReject(payload) {
    return this.http.post(this.blockOrRejectUrl, payload);
  }

  clearAllFilters(): void {
    this.filters = {};
    this.loadData();
  }

  getApplicantDetails(): Observable<any> {
    let params = new HttpParams();

    const input = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      configId: this.tablePayload.currentBatch
    }

    if (this.filters['statusId'] === '401402') {
      delete this.filters['statusId'];
    }

    if (Object.keys(this.filters).length === 0) {
      this.filters = {
        statusId: '401402',
      };
    }


    // Add all active filters ins search params
    Object.entries(this.filters).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value);
      }
    });

    Object.keys(input).forEach(key => {
      const value = input[key as keyof typeof input];
      if (value !== undefined && value !== null) {
        params = params.set(key, String(value));
      }
    });

    return this.http.get(this.gridUrl, { params });
  }



  viewDetails(selectedRow: any) {
    const dialogRef = this.dialog.open(StudentDetailsComponent, {
      width: '90vw',
      maxWidth: '100vw',
      maxHeight: '100%',
      height: '100%',
      panelClass: 'education-sidebar',
      disableClose: false,
      data: {
        data: selectedRow,
        formType: this.tablePayload.currentRole === 'FOCAL_PERSON' ? HEC_CONSTANTS.FOCAL_PERSONS.HEC_APPLICANT : HEC_CONSTANTS.FOCAL_PERSONS.HEC_UNIVERSITY,
        pageState: this.tablePayload.currentRole === 'FOCAL_PERSON' ? HEC_CONSTANTS.FOCAL_PERSONS.HEC : HEC_CONSTANTS.FOCAL_PERSONS.UNIVERSITY
      }
    });
    dialogRef.afterClosed()
      .subscribe(result => {

      });
  }

}
